
import React from "react";
import styles from "./RecentCatchCardSkeleton.module.css";
import cn from 'classnames';
import { Card } from "react-bootstrap";

interface IProps {
    className?: string;
}

const RecentCatchCardSkeleton: React.FC<IProps> = ({ className }) => {
    return (
        <Card bsPrefix={cn(styles.recentCatchCardSkeleton, className)}>
            <Card.Header bsPrefix={styles.recentCatchCardSkeletonHeader}>
                <div className={cn(styles.recentCatchCardSkeletonImage, "shimmer-bg")}></div>
            </Card.Header>
            <Card.Body bsPrefix={styles.recentCatchCardSkeletonBody}>
                <div className={cn(styles.recentCatchCardSkeletonTitle, "shimmer-bg")}></div>
                <div className={cn(styles.recentCatchCardSkeletonItem, "shimmer-bg")}></div>
                <div className={cn(styles.recentCatchCardSkeletonItem, "shimmer-bg")}></div>
                <div className={cn(styles.recentCatchCardSkeletonItem, "shimmer-bg")}></div>
                <div className={cn(styles.recentCatchCardSkeletonItem, "shimmer-bg")}></div>
                <div className={cn(styles.recentCatchCardSkeletonItem, "shimmer-bg")}></div>
            </Card.Body>
        </Card>
    );
};

export default RecentCatchCardSkeleton;
